import moment from "moment";

export class InStockContainer extends React.Component {

    render() {
        return (
            <div className="stock-availability-container">{this.props.stockAvailability !== null && this.props.stockAvailability.map((stockAvailability) => <InStockState key={stockAvailability.locationName} stockAvailability={stockAvailability} />)}</div>
        );
    }
}

export class InStockState extends React.Component {


    render() {

        var stockAvailability = this.props.stockAvailability;

        var className = "";
        var text = "";
        switch (stockAvailability.status) {
            case "Discontinued":
                className = "low-stock";
                text = "Discontinued "+ stockAvailability.amount + " left";

                if (stockAvailability.amount <= 0) {
                    className = "out-stock";
					text = "Discontinued";
                }

                break;
        case "InStock":
            className = "in-stock";
            text = "In Stock";
            break;
        case "LowStock":
            className = "low-stock";
            text = "Only " + stockAvailability.amount + " left";
            break;
        case "OutOfStock":
            className = "out-stock";
            text = "Out of stock";
            if (stockAvailability.eta != null) {
                text = `ETA ${moment(stockAvailability.eta).format("DD MMM")}`;
            }
            break;

        case "SpecialOrderOnly":
            className = "special-order";
            text = "Special Order";
            break;
        }

        if (this.props.hideInStock && className == "in-stock") {
            return null;
        }

        var locationName = <span>{stockAvailability.locationName.replace(' W/H', '').replace('NSW2', 'NSW')}:</span>;
    if (this.props.hideState) {
    locationName = null;
}

return <span className={"stock-availability " + className}>{locationName}{text}</span>;
}
}